export const formatTime = (seconds: number): string => {
    const safe = Math.max(0, Math.floor(seconds))
    const minutes = Math.floor(safe / 60)
    const rest = safe % 60

    return `${minutes}:${String(rest).padStart(2, '0')}`
}
